import { NextSeo } from 'next-seo';
import { GetPathName } from '@/lib/helpers';
import Link from 'next/link';
import Footer from '@/components/Footer';
import { WebdienstFooterCode } from '@/components/codeHighlights/FooterCode';

const Page = () => {
  return (
    <>
      <NextSeo
        title="Webdienst-Footer"
        description="Basiselemente - Das Footer-Element für FHNW-Webdienste."
        canonical={`${process.env.NEXT_PUBLIC_BASE_URL}${GetPathName()}`}
      />

      <h1>Webdienst-Footer</h1>
      <p className="lead">
        Verwenden Sie diesen Footer für{' '}
        <Link href={'/webdienste'}>
          <a>FHNW-Webdienste</a>
        </Link>
        .
      </p>

      <div className="mt-5">
        <Footer />
      </div>
      <div className="mt-5">
        <WebdienstFooterCode />
      </div>
    </>
  );
};

export default Page;
